import { ThemeUICSSObject } from 'theme-ui';
import { responsive } from '../../../../util';

export const overlay: Record<string, ThemeUICSSObject> = {
  overlay: {
    position: 'fixed',
    overflow: 'hidden',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: `palette.background.overlay`,
    zIndex: 'modal',

    '&:not(.screenLock) .modal-enter-done': {
      boxShadow: 'modals',
    },
  },

  windowModal: {
    zIndex: 'modal',
  },

  'overlay--stretch': {
    variant: 'layout.common.modals.overlay',
    alignItems: responsive({ 0: 'stretch', 2: 'center' }),
  },
};
